import cm from 'classnames';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';
import { useAppSignOut } from 'components/app/_mediator/use-app-sign-out';
import { isNull } from 'components/app/_helpers/_app.helper';

import { ReactComponent as UserIco } from 'assets/user.svg';
import { ReactComponent as SignOutIco } from 'assets/sign-out.svg';
import { ReactComponent as ResetPasswordIco } from 'assets/reset-password.svg';
import { ReactComponent as MonthlySubscriptionIcon } from 'assets/monthly-subscription-icon.svg';

import { Logo } from 'components/UI/logo/logo';
import { AppUser } from './app-user';
import styles from '../_app-container.module.scss';

interface HomeModal {
  isActive: boolean;
  onClose: () => void;
}

export const AppModal = ({ isActive, onClose }: HomeModal) => {
  const user = useAppSelector((state) => state.app__data.user);

  const signOut = useAppSignOut();
  const dispatch = useAppDispatch();

  const onAction = (action: ModalEnum) => {
    dispatch(setModal(action));
    onClose();
  };

  return (
    <div className={cm(styles.Modal, { [styles.active]: isActive })}>
      <div className={styles.Modal__box}>
        <Logo className={styles.Modal__logo} />
        <div className={cm(styles.Modal__row, styles['Modal__row--user'])}>
          <div className={styles.Modal__rowLeft}>
            <UserIco />
          </div>
          <div className={styles.Modal__rowRight}>
            <AppUser />
          </div>
        </div>
        <div
          onClick={() => onAction(ModalEnum.subscription)}
          className={cm(styles.Modal__row, styles['Modal__row--link'])}
        >
          <div className={styles.Modal__rowLeft}>
            <MonthlySubscriptionIcon />
          </div>
          <div className={styles.Modal__rowRight}>
            {isNull(user?.subscriptionType) ? 'Buy subscription' : 'Manage subscription'}
          </div>
        </div>
        <div
          onClick={() => onAction(ModalEnum.resetPass)}
          className={cm(styles.Modal__row, styles['Modal__row--link'])}
        >
          <div className={styles.Modal__rowLeft}>
            <ResetPasswordIco />
          </div>
          <div className={styles.Modal__rowRight}>Reset Password</div>
        </div>
        <div onClick={signOut} className={cm(styles.Modal__row, styles['Modal__row--link'])}>
          <div className={styles.Modal__rowLeft}>
            <SignOutIco />
          </div>
          <div className={styles.Modal__rowRight}>Sign Out</div>
        </div>
      </div>
      <div className={styles.Modal__bg} onClick={onClose} />
    </div>
  );
};
